module.exports = __webpack_public_path__ + "static/img/forUsBanner2.a3ad98e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/forUsBanner2.png
// module id = aPY9
// module chunks = 1